var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.57029 5.66667H2.3526C1.3484 5.66667 0.695264 6.70975 1.14436 7.59629L3.50835 12.263C3.73718 12.7147 4.20493 13 4.7166 13H7.43028C7.54073 13 7.65076 12.9866 7.75791 12.9602L10.2983 12.3333M5.57029 5.66667V2.33333C5.57029 1.59695 6.17509 1 6.92115 1H6.98563C7.32305 1 7.59658 1.26998 7.59658 1.60302C7.59658 2.07922 7.73938 2.54477 8.00701 2.94099L10.2983 6.33333V12.3333M5.57029 5.66667H6.92115M10.2983 12.3333H11.6491C12.3952 12.3333 13 11.7364 13 11V7C13 6.26362 12.3952 5.66667 11.6491 5.66667H9.96057",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.65bafdcd10e70232aaee5bae71dcefb3.svg";
export { ForwardRef as ReactComponent };